<p>LAB</p>
<p>{{code}}</p>
<p>{{script}}</p>
<app-scripteditor [options]="{automaticLayout: true, theme: 'vs-dark'}" [(ngModel)]="code"></app-scripteditor>
<app-scripteditor [options]="{automaticLayout: true, theme: 'vs-light'}" [(ngModel)]="script"></app-scripteditor>
